import React from "react";

export const OverviewItemsLayout = {
  Empty: (): JSX.Element => {
    return (
      <div className="page__empty ls-container ls-gutter ls-spacing">
        <p className="text--s">Geen resultaten gevonden.</p>
      </div>
    )
  }
}
